import { api } from './api-client';

export interface ChargebeeSubscription {
  id: string;
  customerId: string;
  status: 'active' | 'cancelled' | 'pending';
  planId: string;
  planAmount: number;
  billingPeriod: number;
  billingPeriodUnit: string;
  currentTermStart: string;
  currentTermEnd: string;
  nextBillingAt: string;
}

export const chargebeeApi = {
  getSubscriptions: (customerId?: string) => 
    api.get<ChargebeeSubscription[]>(`/chargebee/subscriptions${customerId ? `?customer_id=${customerId}` : ''}`),
  
  getSubscription: (subscriptionId: string) => 
    api.get<ChargebeeSubscription>(`/chargebee/subscriptions/${subscriptionId}`),
  
  createSubscription: (data: { customerId: string, planId: string, planQuantity: number }) => 
    api.post<ChargebeeSubscription>('/chargebee/subscriptions', data),
  
  updateSubscription: (subscriptionId: string, data: { planId?: string, planQuantity?: number }) => 
    api.put<ChargebeeSubscription>(`/chargebee/subscriptions/${subscriptionId}`, data),
  
  cancelSubscription: (subscriptionId: string) => 
    api.post<ChargebeeSubscription>(`/chargebee/subscriptions/${subscriptionId}/cancel`, {}),
};
